import { html } from "../../../../../"
import { T } from "../../../../../global/globals"
import { HookFieldGetList } from "../../../../../global/hooks"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
} from "../../../../../global/hooks"
import type { HitListDialogStateType } from "../../../../../state"
import type { _DialogHolderParams } from "../../../../dialog/sysdialogholder"

import { SYSBaseElement } from "../../../../sysbaseelement"
import { SnackAdd } from "../../../../snackapi"
import { _GetFieldList } from "../../../../table/helpers"
import type { SYSField, SYSFormState } from "../../../actions"
import { FilterHitList } from "../../helpers"
import { FieldIsValid } from "../../../fieldapi"
import { _setDialogVisible } from "../../../helper"

let lastNoEntriesMsg = 0
export class SYSHitListDialog extends SYSBaseElement {
  hitListDialogState: HitListDialogStateType

  field: SYSField

  async init() {
    this.hitListDialogState = this.state.ovl.libState.hitListDialogState
    this.formState =
      this.state.ovl.forms[this.hitListDialogState.formType][
        this.hitListDialogState.formId
      ]
    this.field = this.formState.fields[this.hitListDialogState.fieldKey]
    await super.init()
  }

  async getUI() {
    let formState = this.formState
    let field = this.field
    let filterValue = field.list.filterValue

    let filteredKeys = FilterHitList(
      field.list,
      filterValue,
      formState,
      field.fieldKey,
      undefined,
      true,
      "overlay"
    ).filteredKeys
    if (filteredKeys.length < 1) {
      setTimeout(() => {
        let instance =
          this.state.ovl.dialogs.SYSHitListDialog.instance["SYSHitListDialog"]
        if (instance) {
          _setDialogVisible(false, instance)
        }
        let ts = new Date().getTime()
        if (ts - lastNoEntriesMsg > 2000) {
          lastNoEntriesMsg = ts
          SnackAdd(T("SYSNoMatchingEntriesFound"), "Warning", 3000)
          document.getElementById(this.field.id).focus()
        }
      }, 0)
      return
    }
    let body = html`
      <ovl-hitlist
        .props=${() => {
          let listData = _GetFieldList(
            this.actions.app.features[formState.feature].hooks[
              HookFieldGetList.replace(
                "{subFeature}",
                formState.subFeature
              ).replace("{fieldKey}", field.fieldKey)
            ],
            field.fieldKey,
            formState,
            formState?.tableDefId,
            undefined,
            false
          )

          return {
            fieldId: field.id,
            list: field.list,
            listData,
            filterValue,
            filteredKeys,
            type: "overlay",
            selectedFieldKey: field.convertedValue,
            selectedCallback: this.hitListDialogState.selectedCallback,
          }
        }}
      ></ovl-hitlist>
    `

    let footer = html`
      <button
        @click=${() =>
          this.hitListDialogState.selectedCallback("@@ovlcanceled")}
        title="Abbrechen"
        class="fd-button fd-button--negative"
      >
        <i class="sap-icon--decline"></i>
      </button>
    `

    let dialogHolderParams: _DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        customClass: () =>
          this.formState.tableDefId ? `__${this.formState.tableDefId}` : "",
        footer: () => footer,
        body: () => body,
        dismissedCallbackFn: (e) =>
          this.hitListDialogState.selectedCallback("@@ovlcanceled"),
      },

      dialogType: "SYSHitListDialog",
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
  async disconnectedCallback() {
    if (this.hitListDialogState?.selectedCallback) {
      this.hitListDialogState.selectedCallback = null
    }
    this.hitListDialogState = null
    await super.disconnectedCallback()
  }
}
